/**
 * Share Class for implementing social sharing on Facebook, Twitter, LinkedIn, Pinterest, Whatsapp and email.
 *
 * When implementing this share module also:
	- use Yoast plugin, enable open graph en check settings,
	- use the template-part share.php.
 */
export default class Share {
	constructor(element) {

		this.init();
	}

	/**
	 * Function that fires when initializing share in index.js.
	 *
	 * For each share module set the variables, init the social share options and add event listener 'click'.
	 */
	init() {

		document.querySelectorAll('.js-share').forEach((el) => {
			let btn = el.querySelector('.js_share_toggle');

			// Init socials:
			initSocialShares(el);

			// Click event handler:
			btn.addEventListener('click', (e) => {
				e.preventDefault();

				if (el.classList.contains('is-active')) {
					closeShare(el);
				} else {
					checkNatvieShare(el);
				}
			});
		});

		// Close share if click outside button
		document.addEventListener('click', function () {
			document.querySelectorAll('.js_share.is-active').forEach((el) => {
				closeShare(el);
			});
		});

	/**
	 * Function to determine position of the opened share options
	 *
	 * Based on the fold and the top position of the share button, this function will determine if the share options should open above or below the share button.
	 */
		/**
	 * Function to initialize socials media.
	 *
	 * When clicking on the option Facebook, Twitter, LinkedIn or Pinterest, it will open a window, and close the share options.
	 * When clicking on a link it wil close the share options.
	 *
	 * @listens js_facebook~event:eventClick
	 * @listens js_twitter~event:eventClick
	 * @listens js_linkedin~event:eventClick
	 * @listens js_pinterest~event:eventClick
	 * @listens event:eventClick
	 *
	 */
		function initSocialShares(el) {
			// Facebook:
			// el.querySelector('.js_facebook').addEventListener('click', (e) => {
			// 	let loc = e.target.dataset.target;

			// 	window.open('https://www.facebook.com/sharer/sharer.php?u=' + loc, 'facebook-share-dialog', 'width=626,height=436');

			// 	closeShare(el);
			// 	return false;
			// });

			// Twitter:
			// el.querySelector('.js_twitter').addEventListener('click', (e) => {
			// 	let loc = encodeURIComponent(e.target.dataset.target);
			// 	let title = escape(e.target.dataset.title);

			// 	window.open('https://twitter.com/share?url=' + loc + '&text=' + title, 'twitterwindow', 'height=450, width=550');

			// 	closeShare(el);
			// 	return false;
			// });

			// LinkedIn:
			// el.querySelector('.share__item--linkedin').addEventListener('click', (e) => {
			// 	let loc = encodeURIComponent(e.target.dataset.target);

			// 	window.open(
			// 		'https://www.linkedin.com/shareArticle?mini=true&url=' + loc,
			// 		'linkedin-share-dialog',
			// 		'width=650,height=450');

			// 	closeShare(el);
			// 	return false;
			// });

			// Pinterest:
			// el.querySelector('.share__item--pinterest').addEventListener('click', (e) => {
			// 	let loc = encodeURIComponent(e.target.dataset.target);
			// 	let title = escape(e.target.dataset.title);
			// 	let img = escape(e.target.dataset.image);

			// 	window.open(
			// 		'https://www.pinterest.com/pin/create/button/?url=' + loc +
			// 		'&media=' + img +
			// 		'&description=' + title,
			// 		'pinterest-share-dialog',
			// 		'width=650,height=450');

			// 	closeShare(el);
			// 	return false;
			// });

			// Whatsapp & email:
			el.querySelector('.js_share_item').addEventListener('click', (e) => {
				closeShare(el);
			});
		}

		/**
		 * Function to close share options
		 */
		function closeShare(el) {
			el.classList.remove('is-active');
		}

		/**
		 * Function to open share options
		 */
		function openShare(el) {
			// Check if there is a other share button allready open
			let elAllreadyOpen = document.querySelector('.js_share.is-active');

			if (elAllreadyOpen) {
				elAllreadyOpen.querySelector('button').click();
			}

			// setOpenPosition( el );

			setTimeout(() => {
				el.classList.add('is-active');
			}, 10);
		}

		function checkNatvieShare(el) {
			if (navigator.share) {
				let loc = el.dataset.target;
				let title = el.dataset.title;

				navigator
					.share({
						title: title,
						url: loc,
					})
					.then(() => {})
					.catch(console.error);
			} else {
				openShare(el);
			}
		}
	}
}
